import React from 'react';


export default class AlertCard extends React.PureComponent {


    getIcon = (type) => {

        let iconClass;
        switch (type) {

            case 'success':
                iconClass = 'fas fa-check'
                break;
            case 'warning':
            case 'danger':
                iconClass = "fas fa-exclamation"
                break;
            case 'info':
            default:
                iconClass = 'fa fa-info'
                break;
        }

        let textClass = this.props._textClass ?? (this.props.bold ? `has-text-white-bis` : `has-text-${type}-dark`)

        return <i className={`${iconClass} ${textClass} mr-5`}/>
    }

    render() {
        let {type} = this.props;

        let textClass = this.props._textClass ?? ( this.props.bold ? 'has-text-white-bis has-text-weight-semibold' : '')
        let bg = this.props._bgClass || `has-background-${type}${this.props.bold ? '' : '-light'}`

        if (!type || !['success', 'info', 'warning', 'danger'].includes(type)) {
             type = 'info'
        }

        return (
            <div className={`card ${bg} ${this.props.className}`}>
                <div className={`card-content is-flex is-align-content-center`}>
                    <div className={''}>
                         {this.getIcon(type)}
                    </div>
                    {this.props.children || <span className={textClass}>{this.props.msg}</span>}
                </div>
            </div>
        )
    }
}